<ion-app>
  <div id="splashscreen">
    <div id="splashscreenContent"></div>
  </div>
  <ion-progress-bar class='fixed-ion-progress-bar' type="indeterminate" color="dark" *ngIf="isLoading"></ion-progress-bar>
  <ion-router-outlet id="main-content"></ion-router-outlet>
</ion-app>
